import { InjectionToken } from '@angular/core';

import type { DevScenario } from '@arya/shared/domain';

export const DEV_SCENARIOS = new InjectionToken<readonly DevScenario[]>('DEV_SCENARIOS', {
  providedIn: 'root',
  factory: () => [],
});
